/**
 * [CCI-15904] New AIFC Editor Experience — eligibility check.
 *
 * Returns true when the user is enrolled in the "New AIFC Editor Experience" — an umbrella
 * experiment that covers the Post Stream Review toolbar and the Full Page Staging Area.
 *
 * AND-gated with `platform_editor_ai_xstate_migration` because the new experience relies on
 * the xstate / orchestrator architecture (e.g. `buildCommitTransaction` only fires there).
 */
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

/**
 * Returns true when the current user is enrolled in the New AIFC Editor Experience
 * AND in the xstate migration. See file-level JSDoc above for details on what this
 * gate enables.
 */
export function isNewAifcExperienceEnabled(): boolean {
	return (
		expValEquals('platform_editor_ai_xstate_migration', 'isEnabled', true) &&
		expValEquals('platform_editor_ai_new_aifc_editor_experience', 'isEnabled', true)
	);
}
